module.exports = __webpack_public_path__ + "img/home-agenda-Alexandre-Lenoir.6187d21f.jpg";